import { create } from 'zustand';
import commonMiddlewares from '@rs-core/store/middlewares';
import { logWarn } from '@rs-core/utils/logger';

const useMultiMonitorStore = create(
	commonMiddlewares(set => ({
		ivMMSyncedScreens: [], // List of synchronized screens

		// Add or update a synchronized screen
		addSynchronizedScreen: newScreen =>
			set(state => {
				if (newScreen?.screenNumber == null) {
					logWarn('IV::Multi-Monitor', 'newScreen::screenNumber is null', { newScreen });
					return state;
				}
				const exists = state.ivMMSyncedScreens.some(screen => screen.screenNumber === newScreen.screenNumber);
				if (exists) {
					// Update existing screen entry
					return {
						ivMMSyncedScreens: state.ivMMSyncedScreens.map(screen =>
							screen.screenNumber === newScreen.screenNumber ? { ...screen, ...newScreen } : screen
						),
					};
				}
				// Add a new synchronized screen
				return { ivMMSyncedScreens: [...state.ivMMSyncedScreens, newScreen] };
			}),

		// Update an existing synchronized screen
		updateSynchronizedScreen: updatedScreen =>
			set(state => ({
				ivMMSyncedScreens: state.ivMMSyncedScreens.map(screen =>
					screen.screenNumber === updatedScreen.screenNumber ? { ...screen, ...updatedScreen } : screen
				),
			})),

		// Remove a synchronized screen when closed
		removeSynchronizedScreen: screenNumber =>
			set(state => ({
				ivMMSyncedScreens: state.ivMMSyncedScreens.filter(screen => screen.screenNumber !== screenNumber),
			})),

		// Clear all synchronized screens
		clearSynchronizedScreens: () => set({ ivMMSyncedScreens: [] }),
	}))
);

export default useMultiMonitorStore;
